import React, { memo } from 'react';
import style from './chart.module.scss';
import { hoverBG, toolTipBG } from '../../../../components/icons/icons.jsx'

const InfoTooltip = memo(({ exclamationIcon }) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  return (
    <div className={style.exclamation} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
      <img src={exclamationIcon} alt="info"/>
      {showTooltip && (
          <div style={{backgroundImage: `url(${toolTipBG})`}} className={style.top10Hover}>
            <div>
                <span>REACH</span> indicates the % of respondents who identify with this need<br/>
                <span>IMPORTANCE</span> indicates the average % importance that respondents assign to this need<br/>
                <span>WTP</span> indicates the average % extra amount respondents are willing to pay to fullfil this need
            </div>
          </div>
      )}
    </div>
  );
});

InfoTooltip.displayName = 'InfoTooltip';

export default InfoTooltip; 